import {
  SectionWrapper,
  BrowserWrapper,
  ContentWrapper,
  Title,
  Description,
} from './styled';
import BrowserBox from '../BrowserBox';

interface SectionBrowserProps {
  title: string;
  description: string;
  image: string;
  reverse?: boolean;
}

function SectionBrowser({
  reverse,
  title,
  description,
  image,
}: SectionBrowserProps) {
  return (
    <SectionWrapper reverse={reverse}>
      <ContentWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </ContentWrapper>
      <BrowserWrapper>
        <BrowserBox image={image} />
      </BrowserWrapper>
    </SectionWrapper>
  );
}

export default SectionBrowser;
